import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import AnimationSlideRight from "../../../Animation/AnimationSlideRight";
import AnimationSlideLeft from "../../../Animation/AnimationSlideLeft";
import event1 from "../../../Assest/Images/event1.jfif";
import event2 from "../../../Assest/Images/event2.jfif";
import event3 from "../../../Assest/Images/event3.jfif";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import colors from "../../../Assest/Theme/Color";
import useTranslations from "../../Translations/useTranslations";
import regstart from "../../../Assest/Images/regstart.jpg";
import teachermeet from "../../../Assest/Images/teachermeet.jpg";
import evaluation from "../../../Assest/Images/evaluation.jpg";
import fstdayschl from "../../../Assest/Images/fstdayschool.jpg";
import Routings from "../../../Routings";
import { useNavigate } from "react-router-dom";
import {
  Close as CloseIcon,
} from "@mui/icons-material";


const CustomPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    color: "#000000",
    borderColor: "#fff",
    backgroundColor: "#fff",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#2F80ED",
    color: "#FFFFFF",
  },
  "& .MuiPaginationItem-root:hover": {
    backgroundColor: "#2F80ED",
    color: "#FFFFFF",
  },
}));

const datas = [
  {
    id: 1,
    name: "Official Start/ Registration Start",
    description:
      "Welcome to a new year of learning and growth! Kickstart your journey with us—enroll today and be ready to succeed. Together, we begin a fresh chapter of opportunity and achievement.",
    date: "25-06-2025",
    time: "00:12:00",
    text: "“Let the Learning Journey Start!”",
    registrationLink: "https://www.keelis.com/",
    imageUrl: regstart,
    createdAt: "2025-06-24T09:30:23.862Z",
    updatedAt: "2025-06-24T09:30:23.862Z",
    redirect: true,
  },
  {
    id: 2,
    name: "Teachers Meet",
    description:
      "Collaborating to inspire and empower every learner.Sharing ideas, planning goals, and strengthening our community.Together, we shape the future of education!",
    date: "19-07-2025 (Saturday)",
    time: "09:00:00",
    text: "“Collaborating for a Stronger School Year”",
    registrationLink: "https://www.keelis.com/",
    imageUrl: teachermeet,
    createdAt: "2025-06-24T09:31:10.000Z",
    updatedAt: "2025-06-24T09:31:10.000Z",
    redirect: false,
  },
  {
    id: 3,
    name: "Evaluation",
    description:
      "Reflecting on progress to grow stronger together. Focused on continuous improvement for student success.Together, we strive for excellence in teaching and learning.",
    date: "25-07-2025",
    time: "08:00:00",
    text: "“Committed to Continuous Improvement”",
    registrationLink: "https://www.keelis.com/",
    imageUrl: evaluation,
    createdAt: "2025-06-24T09:32:00.000Z",
    updatedAt: "2025-06-24T09:32:00.000Z",
    redirect: false,
  },
  {
    id: 4,
    name: "Open House/ First Day of School",
    description:
      "Welcome to the new school year! Join us for Open House and get ready for a great first day of learning and growth. Let’s make this year amazing together!",
    date: "08-08-2025",
    time: "14:00:00",
    text: "“New Beginnings Start Here!”",
    registrationLink: "https://www.keelis.com/",
    imageUrl: fstdayschl,
    createdAt: "2025-06-24T09:33:12.000Z",
    updatedAt: "2025-06-24T09:33:12.000Z",
    redirect: false,
  },
];

function Event() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { translations } = useTranslations();
  const [images, setImages] = useState([]);
  const [events, setEvents] = useState([]);

  const handleRedirect = () => {
    window.open(colors.registerUSurl, "_blank");
  };

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: isMobile ? "" : "0 4rem",
    },

    heading: {
      fontSize: "32px",
      fontFamily: "Caveat, serif",
      fontWeight: "bold",
      color: colors.secondary,
      marginBottom: "10px",
      textAlign: "left",
    },
    subheading: {
      fontSize: isMobile ? "24px" : "32px",
      fontWeight: "bold",
      color: colors.lightText,
      marginBottom: "5px",
      textAlign: "left",
    },
    subText: {
      textAlign: "left",
      color: colors.lightText,
    },

    button: {
      backgroundColor: "#62c5f5",
      color: colors.black,
      fontSize: "18px",
      fontWeight: "bold",
      textTransform: "none",
      padding: "8px 30px",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#4aaee1",
      },
    },

    imgContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      height: isMobile ? "250px" : "300px",
    },
    image: {
      borderRadius: "50%",
      position: "absolute",
    },
    imageLeft: {
      width: isMobile ? "130px" : "220px",
      left: isMobile ? 24 : 50,
      top: isMobile ? 64 : 30,
    },
    imageCenter: {
      width: isMobile ? "150px" : "250px",
      zIndex: 1,
    },
    imageRight: {
      width: isMobile ? "130px" : "220px",
      zIndex: 2,
      right: isMobile ? 21 : 60,
      top: isMobile ? 64 : 40,
    },
  };

  useEffect(() => {
    setEvents(datas);
    setImages(datas.map((item) => item.imageUrl));
  }, []);
  // const getEvents = async () => {
  //   try {
  //     const response = await fetchData("/admin/event/list");

  //     if (response?.data?.length) {
  //       setEvents(response.data);
  //       setImages(response.data.map((item) => item.imageUrl));
  //     } else {
  //       setEvents([]);
  //       setImages([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching events: ", error);
  //     setEvents([]);
  //     setImages([]);
  //   }
  // };
  const eventsPerPage = 10; // Default number of events per page
  const [page, setPage] = useState(1);
  const [registerModalOpen, setRegisterModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Calculate the events to display based on the current page
  const startIndex = (page - 1) * eventsPerPage;
  const endIndex = startIndex + eventsPerPage;
  const displayedevents = events?.slice(startIndex, endIndex);

  return (
    <div
      style={{
        paddingTop: isMobile ? "4rem" : "6rem",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Dialog
        open={registerModalOpen}
        onClose={() => setRegisterModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <IconButton
          onClick={() => setRegisterModalOpen(false)}
          sx={{ position: "absolute", top: 8, right: 8, color: "#9CA3AF" }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ textAlign: "center", fontWeight: 700, fontSize: "20px", color: "#3B4E8C", pt: 4, lineHeight: 1.4 }}>
          Are you a new student<br />or an existing student?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center", color: "#6B7280", fontSize: "14px" }}>
            Please select an option to continue your registration.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
          <Button
            variant="contained"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "new" },
              });
            }}
            sx={{
              backgroundColor: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#2d3d6e" },
            }}
          >
            New Student
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "old" },
              });
            }}
            sx={{
              borderColor: "#3B4E8C",
              color: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#f0f2f8" },
            }}
          >
            Existing Student
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={styles.container}>
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: isMobile ? "100%" : "80vh",
            }}
          >
            <AnimationSlideLeft duration={1.5} rootMargin={"-10px"}>
              <Box sx={{ p: isMobile ? "0 2rem" : 4 }}>
                <AnimationSlideLeft duration={1.2} rootMargin={"-10px"}>
                  <Typography style={styles.subheading}>
                    <span style={styles.heading}>
                      {translations.ourEventsHeading.split(" ")[0]}{" "}
                    </span>
                    {translations.ourEventsHeading.split(" ")[1]}
                  </Typography>
                </AnimationSlideLeft>
                <Typography
                  // key={index}
                  sx={{
                    textAlign: "left",
                    color: colors.lightText,
                    marginBottom: "8px",
                  }}
                >
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout.
                </Typography>
                {/* {events.length > 0 ? (
                  events.map((event, index) => (
                    <Typography
                      key={index}
                      sx={{
                        textAlign: "left",
                        color: colors.lightText,
                        marginBottom: "8px",
                      }}
                    >
                      {event.description}
                    </Typography>
                  ))
                ) : (
                  <Typography
                    sx={{ textAlign: "left", color: colors.lightText }}
                  >
                    No events available
                  </Typography>
                )} */}
              </Box>
            </AnimationSlideLeft>
          </Grid>

          <Grid
            item
            xs={12}
            md={7}
            p={isMobile ? 1 : 2}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: isMobile ? "100%" : "80vh",
            }}
          >
            <AnimationSlideRight duration={1.5} rootMargin={"-10px"}>
              <div style={styles.imgContainer}>
                {images.length > 0 ? (
                  <>
                    <img
                      src={images[0]}
                      style={{ ...styles.image, ...styles.imageLeft }}
                      alt="event1"
                    />
                    <img
                      src={images[1]}
                      style={{ ...styles.image, ...styles.imageCenter }}
                      alt="event2"
                    />
                    <img
                      src={images[2]}
                      style={{ ...styles.image, ...styles.imageRight }}
                      alt="event3"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={event3}
                      style={{ ...styles.image, ...styles.imageLeft }}
                      alt="event1"
                    />
                    <img
                      src={event2}
                      style={{ ...styles.image, ...styles.imageCenter }}
                      alt="event2"
                    />
                    <img
                      src={event1}
                      style={{ ...styles.image, ...styles.imageRight }}
                      alt="event3"
                    />
                  </>
                )}
              </div>
            </AnimationSlideRight>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ px: 6, pb: 6 }}>
        {displayedevents.map((event) => (
          <Grid container key={event.id} mt={4}>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={event.imageUrl}
                alt={event.title}
                sx={{
                  width: isMobile ? 200 : 250,
                  height: isMobile ? 200 : 250,
                  objectFit: "cover",
                  borderRadius: "25px",
                }}
              />
            </Grid>

            <Grid item xs={12} md={8} pr={2} mt={3}>
              <Box sx={{ textAlign: "left" }}>
                <Typography
                  sx={{
                    fontSize: isMobile ? "20px" : "26px",
                    fontWeight: "bold",
                  }}
                >
                  {event.name}
                </Typography>
                <Typography
                  sx={{
                    fontSize: isMobile ? "18px" : "20px",
                    fontWeight: "bold",
                    color: "#336599",
                  }}
                >
                  {event.text}
                </Typography>
                <Typography
                  sx={{
                    fontSize: isMobile ? "15px" : "17px",
                    fontWeight: "bold",
                    color: "#336599",
                  }}
                >
                  {event.date}
                </Typography>
                <Typography
                  sx={{
                    fontSize: isMobile ? "20px" : "26px",
                    fontWeight: "bold",
                  }}
                >
                  {event.title}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: 1,
                    color: colors.secondary,
                    fontWeight: "bold",
                  }}
                >
                  {event.subtitle}
                </Typography>
                <Typography variant="body2" sx={{ color: "#ABABAB" }}>
                  {event.description}
                </Typography>
                {event.redirect === true && (
                  <Button
                    size="small"
                    sx={{
                      textTransform: "none",
                      marginTop: 2,
                      backgroundColor: colors.secondary,
                      color: colors.white,
                      px: 1.7,
                      cursor: event.redirect === true ? "pointer" : "auto",
                    }}
                    onClick={() => setRegisterModalOpen(true)}
                  >
                    Register Now
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        ))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
        <Stack spacing={2}>
          <CustomPagination
            count={Math.ceil(events.length / eventsPerPage)}
            variant="outlined"
            page={page}
            onChange={handleChangePage}
            shape="rounded"
          />
        </Stack>
      </Box>
    </div>
  );
}

export default Event;
